import { render, staticRenderFns } from "./ContentThumbnail.vue?vue&type=template&id=4ff47be5&"
import script from "./ContentThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ContentThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports